import { forwardRef } from "react";

import { DateTime } from "luxon";

import { useLocaleContext } from "@/contexts/LocaleContext";
import { BaseFormDate, BaseFormDateProps } from "@/forms-design-system/FormDate/BaseFormDate";
import { formatTimeWithTimezone, getDate, shouldDisplayYear } from "@/forms-design-system/FormDate/helper";
import { useTranslate } from "@/hooks/useTranslate";

export type LabeledFormDateProps = Omit<BaseFormDateProps, "subtitle"> & {
  now?: Date;
};

export const LabeledFormDate = forwardRef<HTMLDivElement, LabeledFormDateProps>(({ date, now, ...rest }, ref) => {
  const { isoLocale } = useLocaleContext();
  const luxonNow = now ? getDate(now) : DateTime.now();
  const luxonDate = getDate(date);
  const { t } = useTranslate();

  const timeDisplay = formatTimeWithTimezone(luxonDate, isoLocale);

  return (
    <BaseFormDate
      date={date}
      subtitle={t("common", "dateRangeStartDate", {
        date: luxonDate.toLocaleString(
          {
            year: shouldDisplayYear(luxonDate, luxonNow) ? "numeric" : undefined,
            month: "short",
            day: "numeric",
          },
          { locale: isoLocale }
        ),
        time: timeDisplay,
      })}
      {...rest}
      ref={ref}
    />
  );
});

LabeledFormDate.displayName = "LabeledFormDate";
